import { useTranslation } from 'react-i18next';
import './TripDuration.scss';
import { formatDate } from '../../../utils/utils';

interface TripDurationProps {
  requestStartDate: string,
  requestEndDate: string,
  frequency: number
}

const TripDuration = ({
  requestStartDate,
  requestEndDate,
  frequency,
}: TripDurationProps) => {
  const { t } = useTranslation();

  return (
    <div className="TripDuration">
      <div className="TripDurationDuration">
        <h3 className="TripDurationTitle">{t('trips.duration.duration')}</h3>
        <span className="TripDurationValue">
          {formatDate(requestStartDate)} {t('trips.duration.to')} {formatDate(requestEndDate)}
        </span>
      </div>
      <div>
        <h3 className="TripDurationTitle">{t('trips.duration.frequency')}</h3>
        <span className="TripDurationValue">{frequency === 1 ? t('trips.duration.eachWeek') : t('trips.duration.every', { amount: frequency })}</span>
      </div>
    </div>
  );
};

export default TripDuration;